var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"active":_vm.loading,"indeterminate":""}}),(_vm.product)?_c('product-prices',{staticClass:"my-4",attrs:{"product":_vm.product}}):_vm._e(),(_vm.product)?_c('product-tags',{staticClass:"mb-4",attrs:{"product":_vm.product}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }